import { Identity } from '../api/types/Identity'
import { logger } from '../utils/logging'
import { usePylon } from './PylonContext'
/**
 * NOTE: be careful that every dependency you have here has safe handling for working offline or in dev mode
 */
export function useTracking() {
  const pylon = usePylon()
  // ADD OTHER TRACKERS HERE

  // Utility function to split full name into first and last name
  const splitName = (fullName: string) => {
    const parts = fullName.split(' ')
    return {
      firstName: parts[0] || '',
      lastName: parts.length > 1 ? parts.slice(1).join(' ') : '',
    }
  }

  return {
    capture(_event: string, _info?: Record<string, any>) {
      // PostHog tracking removed
    },
    identify(identity: Identity) {
      const { firstName, lastName } = splitName(identity.user.name)

      pylon.configure({
        account_id: identity.account.id,
        email: identity.user.email,
        name: identity.user.name,
      })
      // PostHog identify/group calls removed

      logger.setContext({ user: identity.user.id, account: identity.account.id })

      if ((window as any).Appcues) {
        ;(window as any).Appcues.identify(identity.user.id, {
          // Unique identifier for the user
          email: identity.user.email,
          fullName: identity.user.name,
          firstName,
          lastName,
          resourceOnlyAdmin: identity.environments.length === 0,
          // Add any other user properties
          company: identity.account.name,

          dashboard_version: identity.account.dashboard,
        })
      }
    },
  }
}
